import { render, staticRenderFns } from "./alertNotifyPop.vue?vue&type=template&id=5850713d&scoped=true"
import script from "./alertNotifyPop.vue?vue&type=script&setup=true&lang=js"
export * from "./alertNotifyPop.vue?vue&type=script&setup=true&lang=js"
import style0 from "./alertNotifyPop.vue?vue&type=style&index=0&id=5850713d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5850713d",
  null
  
)

export default component.exports